import React, {Component} from 'react';
import up from '../../../assets/svg/icons/up.svg';
import down from '../../../assets/svg/icons/down.svg';
import PropTypes from 'prop-types';
import classNames from 'classnames';

class Stepper extends Component {
    state = {
        value: this.props.defaultValue ? parseInt(this.props.defaultValue, 10) : '',
    };

    onChange = (value) => {
        const validated = this.validateValue(value);
        if (validated !== this.state.value) {
            this.setState({value: validated});
            this.props.onChange && this.props.onChange(validated === '' ? null : validated);
        }
    };

    increment = () => {
        this.onChange(this.state.value + this.props.step);
    };

    decrement = () => {
        this.onChange(this.state.value - this.props.step);
    };

    validateValue = (value) => {
        if (value === "" || value === null) {
            return "";
        }

        const newValue = parseInt(value, 10);

        if (this.props.max !== null && newValue > this.props.max) {
            return this.props.max;
        } else if (this.props.min !== null && newValue < this.props.min) {
            return this.props.min;
        } else {
            return newValue;
        }
    };

    formatValue = () => {
        const prefix = this.props.prefix || '';
        const postfix = this.props.postfix || '';
        return this.state.value !== "" ? prefix + this.state.value + postfix : "";
    };

    render() {
        const {className, invalid, label, placeholder, prefix, postfix, size, valid} = this.props;

        const leftButton = classNames('stepper-button', 'stepper-button-left', {
            'stepper-button-disabled': this.props.min !== null && this.state.value === this.props.min,
            'stepper-button-left-hover': !(this.props.min !== null && this.state.value === this.props.min),
        });

        const rightButton = classNames('stepper-button', 'stepper-button-right', {
            'stepper-button-disabled': this.props.max !== null && this.state.value === this.props.max,
            'stepper-button-right-hover': !(this.props.max !== null && this.state.value === this.props.max),
        });

        const container = classNames('stepper-container', {
            'stepper-container-sm': size === 'sm',
            'stepper-valid': valid,
            'stepper-invalid': invalid,
        });

        const outer = classNames('stepper-outer', className);

        return (
            <div className={outer}>
                {label}
                <div className={container}>
                    <div className={leftButton} onClick={this.decrement}>
                        <img src={down} alt=""/>
                    </div>
                    <div>
                        <input className="stepper-input" type="text" value={this.formatValue()} onChange={(e) => this.onChange(e.target.value.replace(/\D/g, ''))}
                               placeholder={placeholder || prefix || postfix}/>
                    </div>
                    <div className={rightButton} onClick={this.increment}>
                        <img src={up} alt=""/>
                    </div>
                </div>
                {
                    valid && (typeof valid === 'string') ? (<small className="text-success">{valid}</small>)
                        : (invalid && typeof invalid === 'string') ? (<small className="text-danger">{invalid}</small>)
                        : null
                }
            </div>
        );
    }
}

Stepper.defaultProps = {
    step: 1,
};

Stepper.propTypes = {
    className: PropTypes.string,
    defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    invalid: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    label: PropTypes.string,
    max: PropTypes.number,
    min: PropTypes.number,
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    postfix: PropTypes.string,
    prefix: PropTypes.string,
    size: PropTypes.string,
    step: PropTypes.number,
    valid: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

export default Stepper;


// WEBPACK FOOTER //
// ./src/components/controls/inputs/Stepper.js